/**
 * App package registry — GENERATED, do not hand-edit.
 *
 * Regenerate with `yarn workspace @mono/thousand-sunny gen:apps` after
 * adding, removing, or renaming an app package under uis/*. The generator
 * (scripts/gen-apps.mjs) derives this list from the shell's own
 * package.json dependencies, so a hand-edit here only gets overwritten and
 * hides a decision that belongs in package.json.
 */ import { trackingProfilesManifest } from '@mono/tracking-profiles/manifest';
import { lazy } from 'react';
export const appRegistry = [
    {
        id: trackingProfilesManifest.id,
        basePath: trackingProfilesManifest.basePath,
        manifest: trackingProfilesManifest,
        Component: lazy(()=>import('@mono/tracking-profiles/mount'))
    }
];
